import { FunctionComponent } from 'react'
import { Flyout } from '~/components/Flyout'

const HELP_TEXT_CLASSES = 'flex flex-col gap-6 [&_div>p]:inline-flex [&_div>p]:flex-col [&_h2]:mb-3 [&_ol]:m-0 [&_ol]:ml-5 [&_ol]:p-0 [&_ul]:m-0 [&_ul]:ml-5 [&_ul]:p-0'

export const PureAdmIntegrationHelpFlyout: FunctionComponent = () => (
  <Flyout.Content>
    <Flyout.Title>Help</Flyout.Title>
    <Flyout.Body>
      <div className={HELP_TEXT_CLASSES}>
        <div>
          <h2>How can I integrate a Prebid bidder to my site?</h2>
          {/* Both paths, because both exist: the mappings are edited in the table on this page, and the CSV
              round-trip lives behind "Advanced options for all medias". The CSV was the only one described
              here for as long as it was the only one there was. */}
          <p>
            <span>Fill the bid params in the mapping table, one line per ad unit, and save.</span>
            <span>On a large inventory, work from the CSV instead — open “Advanced options for all medias”:</span>
          </p>
          <ol>
            <li>Download the mapping, or the empty template if you are starting from nothing.</li>
            <li>Fill the file with the bid params this bidder gave you.</li>
            <li>Upload it back. Pubstack checks its integrity before applying it.</li>
          </ol>
          <p>Either way, deploy the stacks afterwards to use the bidder in production.</p>
        </div>

        <div>
          <h2>Where can I find the bidder information?</h2>
          <ul>
            <li>Check bid params on the bidder’s site.</li>
            <li>Contact directly your account manager’s bidder partner.</li>
          </ul>
        </div>

        <div>
          <h2>What if I made a mistake?</h2>
          <p>
            <span>If bid params are wrong, the bidder will not be called for the corresponding ad unit, which will not be monetised by the bidder.</span>
            <span>Please ensure that:</span>
          </p>
          <ul>
            <li>Uploaded mapping file corresponds to the right bidder partner.</li>
            <li>Bid params are well filled: be careful of type and values defined on bidder’s site.</li>
          </ul>
        </div>

        <div>
          <h2>Note about array values</h2>
          <p>
            <span>Array values are a specific case since they use commas to separate values, which is also the case for CSV files.</span>
            <span>To avoid any errors, please follow these rules when filling in array values:</span>
          </p>
          <ul>
            <li>
              Values are contained between brackets (<code>[]</code>).
            </li>
            <li>
              The whole array is surrounded with quotes (<code>""</code>). This is mandatory but usually done automatically by your spreadsheet software.
            </li>
          </ul>
          <p>
            A proper array value should look like this in the CSV file: <code>"[value1,value2]"</code>
          </p>
        </div>

        <div>
          <h2>What if I do not want to map everything?</h2>
          <p>If you do not want to map a specific line, leave it in the file with empty params.</p>
        </div>
      </div>
    </Flyout.Body>
  </Flyout.Content>
)
